import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../../models/api-response.model';
import { Statistics } from '../../models/statistics.model';

@Injectable()
export class ApiService {
    public pingStream: Subject<number> = new Subject<number>();

    constructor(private http: HttpClient) { }

    public getValuations(limit: any, page: any, orderBy: string, filter: any, fields: any, defaultFilter: any) {
        const headers = new HttpHeaders();
        headers.append('Accept', 'application/json');
        return this.http.get<ApiResponse>(`${environment.apiUrl}/request/v1/valuation/?limit=` + limit + '&page=' +
            page + '&orderBy=' + orderBy + '&filter=' + filter + '&defaultFilter=' + defaultFilter + '&fields=' + fields, { headers: headers })
    }

    public getValuationID(id: string, fields = '') {
        const headers = new HttpHeaders();
        headers.append('Accept', 'application/json');
        return this.http.get<ApiResponse>(`${environment.apiUrl}/request/v1/valuation/` + id, { headers: headers })
    }

    public getBodyTypes() {
        const headers = new HttpHeaders();
        headers.append('Accept', 'application/json');
        const orderBy = [{ 'field': 'sequence', 'direction': 'ASC' }, { 'field': 'descriptionNl', 'direction': 'ASC' }];
        return this.http.get<ApiResponse>(`${environment.apiUrl}/vehicle/v1/body-type/?limit=1000&page=1&orderBy=` + JSON.stringify(orderBy), { headers: headers })
    }

    public getColorTypes() {
        const headers = new HttpHeaders();
        headers.append('Accept', 'application/json');
        return this.http.get<ApiResponse>(`${environment.apiUrl}/vehicle/v1/color-type/`, { headers: headers })
    }

    public getFuelTypes() {
        const headers = new HttpHeaders();
        headers.append('Accept', 'application/json');
        return this.http.get<ApiResponse>(`${environment.apiUrl}/vehicle/v1/fuel-type/`, { headers: headers })
    }

    public getVehicleTypes() {
        const headers = new HttpHeaders();
        headers.append('Accept', 'application/json');
        return this.http.get<ApiResponse>(`${environment.apiUrl}/vehicle/v1/vehicle-type/`, { headers: headers })
    }

    public getMakes() {
        const headers = new HttpHeaders();
        headers.append('Accept', 'application/json');
        return this.http.get<ApiResponse>(`${environment.apiUrl}/vehicle/v1/make/?limit=1000&page=1`, { headers: headers })
    }

    public getModels(filter: string) {
        const headers = new HttpHeaders();
        headers.append('Accept', 'application/json');
        return this.http.get<ApiResponse>(`${environment.apiUrl}/vehicle/v1/model-specific/?limit=1000&page=1&filter=` + filter, { headers: headers })
    }

    public getTransmissionTypes() {
        const headers = new HttpHeaders();
        headers.append('Accept', 'application/json');
        const orderBy = [{ 'field': 'sequence', 'direction': 'ASC' }, { 'field': 'descriptionNl', 'direction': 'ASC' }];
        return this.http.get<ApiResponse>(`${environment.apiUrl}/vehicle/v1/transmission-type/?limit=1000&page=1&orderBy=` + JSON.stringify(orderBy), { headers: headers })
    }

    public gatherAccountSettingOptions() {
        const headers = new HttpHeaders();
        headers.append('Accept', 'application/json');
        return this.http.get<ApiResponse>(`${environment.apiUrl}/account/v1/setting-type/`, { headers: headers })
    }

    public getAccountSetting() {
        const headers = new HttpHeaders();
        headers.append('Accept', 'application/json');
        return this.http.get<ApiResponse>(`${environment.apiUrl}/account/v1/setting/?limit=25&page=1`, { headers: headers })
    }

    public updateAccountSetting(value: string, settingTypeId: string) {
        const headers = new HttpHeaders();
        const body = { 'value': value, 'settingTypeId': settingTypeId };
        headers.append('Accept', 'application/json');
        return this.http.put<ApiResponse>(`${environment.apiUrl}/account/v1/setting/` + settingTypeId, body, { headers: headers })
    }

    public createAccountSetting(value: string, settingTypeId: string) {
        const headers = new HttpHeaders();
        const body = { 'value': value, 'settingTypeId': settingTypeId };
        headers.append('Accept', 'application/json');
        return this.http.post<ApiResponse>(`${environment.apiUrl}/account/v1/setting/`, body, { headers: headers })
    }

    public addBid(bid: string, comment: string, bidListId: string) {
        const headers = new HttpHeaders();
        const body = { 'bid': bid, 'comment': comment, 'bidListId': bidListId };
        headers.append('Accept', 'application/json');
        return this.http.post<ApiResponse>(`${environment.apiUrl}/trade/v1/expert-bid/`, body, { headers: headers })
    }

    public addBidComment(comment: string, bidListId: string) {
        const headers = new HttpHeaders();
        const body = { 'comment': comment };
        headers.append('Accept', 'application/json');
        return this.http.put<ApiResponse>(`${environment.apiUrl}/trade/v1/expert-bid/` + bidListId, body, { headers: headers })
    }

    public getTransports(limit: any, page: any, orderBy: string, filter: any, fields: any, defaultFilter: any) {
        const headers = new HttpHeaders();
        headers.append('Accept', 'application/json');
        return this.http.get<ApiResponse>(`${environment.apiUrl}/transport/v1/request/?limit=` + limit + '&page=' +
            page + '&orderBy=' + orderBy + '&filter=' + filter + '&defaultFilter=' + defaultFilter + '&fields=' + fields, { headers: headers })
    }


    public getQueues(limit: any, page: any, orderBy: string, filter: any, fields: any, defaultFilter: any) {
        const headers = new HttpHeaders();
        headers.append('Accept', 'application/json');
        return this.http.get<ApiResponse>(`${environment.apiUrl}/api/v1/queue/?limit=` + limit + '&page=' +
            page + '&orderBy=' + orderBy + '&filter=' + filter + '&defaultFilter=' + defaultFilter + '&fields=' + fields, { headers: headers })
    }

    public getAwsAlerts(limit: any, page: any, orderBy: string, filter: any, fields: any, defaultFilter: any) {
        const headers = new HttpHeaders();
        headers.append('Accept', 'application/json');
        return this.http.get<ApiResponse>(`${environment.apiUrl}/api/v1/alert/?limit=` + limit + '&page=' +
            page + '&orderBy=' + orderBy + '&filter=' + filter + '&defaultFilter=' + defaultFilter + '&fields=' + fields, { headers: headers })
    }

    public statisticsSearch(index: string, requestBody: string) {
        const RequestHeaders = new HttpHeaders().set('Accept', 'application/json');
        let Params = new HttpParams()
        Params = Params.append('index', index);
        Params = Params.append('requestBody', requestBody);
        return this.http.get<Statistics>(environment.apiUrl + '/statistics/v1/query',
            { headers: RequestHeaders, params: Params });
    }

    public statisticsCount(index: string, requestBody: string) {
        const RequestHeaders = new HttpHeaders().set('Accept', 'application/json');
        let Params = new HttpParams()
        Params = Params.append('index', index);
        Params = Params.append('requestBody', requestBody);
        return this.http.get<Statistics>(environment.apiUrl + '/statistics/v1/count',
            { headers: RequestHeaders, params: Params });
    }

    public getPing() {
        return this.http.get<any>('https://1.1.1.1/')
    }

    public getIP() {
        return this.http.get<any>('https://api.ipify.org?format=json')
    }

    public getBuyAmounts() {
        const headers = new HttpHeaders()
            .set('Accept', 'application/json')
            .set('Cache-Control', 'no-cache')
            .set('Pragma', 'no-cache');
        return this.http.get<any>(
            `https://api.npoint.io/f4b37e6a1c68a82e5a73?_=${Date.now()}`,
            { headers }
        )
    }

    public getYearTargets() {
        const headers = new HttpHeaders()
            .set('Accept', 'application/json')
            .set('Cache-Control', 'no-cache')
            .set('Pragma', 'no-cache');
        return this.http.get<any>(
            `https://api.npoint.io/2a141b5b1a21429ad7ca?_=${Date.now()}`,
            { headers }
        )
    }

    public getBitcoinPrice() {
        return this.http.get<any>('https://api.coinbase.com/v2/prices/BTC-EUR/spot');
    }

    public getLitecoinPrice() {
        return this.http.get('https://api.coinbase.com/v2/prices/LTC-EUR/spot')
    }

    public getEtheriumPrice() {
        return this.http.get<any>('https://api.coinbase.com/v2/prices/ETH-EUR/spot')
    }

    public getCardanoPrice() {
        return this.http.get<any>('https://api.coinbase.com/v2/prices/ADA-EUR/spot')
    }

    public getQuantPrice() {
        return this.http.get<any>('https://api.coinbase.com/v2/prices/QNT-EUR/spot')
    }

    public getAppVersionFromNgSw(): Promise<string | null> {
        return fetch('/ngsw.json')
            .then(res => res.json())
            .then(json => {
                const mainFile = json.assetGroups?.find((g: any) => g.name === 'app')?.urls
                    ?.find((url: string) => url.startsWith('/main-'));
                const match = mainFile?.match(/main-([^.]+)\.js/);
                return match?.[1] || null;
            })
            .catch(() => null);
    }
}
